import {
  SET_SERVER_TIME,
  INITIALIZE_APP,
  INITIALIZE_APP_COMPLETED,
  SET_CONNECTED,
  SET_SCREEN_SIZE,
  SET_DEVICE_INFO,
} from './app.actions';
import { CONFIG_INIT } from './app.config.actions';

export const initialState = {
  ads: null,
  deviceBrand: '',
  deviceModel: '',
  deviceVersion: '',
  givenConsentVersion: 0,
  initializing: false,
  initialized: false,
  initialElapsedTime: null,
  initializeRetriesCount: 0,
  serverTime: null,
  hasKeysControl: true,
  startoverMinDepth: null,
  startoverMaxDepth: null,
  startoverMinPercentage: null,
  startoverMaxPercentage: null,
  country: null,
  currentService: null,
  connected: true,
  screenSize: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case INITIALIZE_APP: {
      return {
        ...state,
        initializing: true,
        initialElapsedTime: action.initialElapsedTime,
        initializeRetriesCount: state.initializeRetriesCount + 1,
      };
    }

    case INITIALIZE_APP_COMPLETED: {
      return {
        ...state,
        initializing: false,
        initialized: true,
      };
    }

    case SET_SERVER_TIME:
      return {
        ...state,
        serverTime: action.serverTime,
      };

    case CONFIG_INIT: {
      const {
        ads,
        country,
        monitoring,
        customizer,
        analytics,
        startover: { startoverMinDepth, startoverMaxDepth, startoverMinPercentage, startoverMaxPercentage },
      } = action.config;

      return {
        ...state,
        ads,
        country,
        monitoring,
        customizer,
        analytics,
        givenConsentVersion: action.consentVersion,
        startoverMinDepth,
        startoverMaxDepth,
        startoverMinPercentage,
        startoverMaxPercentage,
      };
    }

    case SET_CONNECTED: {
      return {
        ...state,
        connected: action.connected,
      };
    }

    case SET_SCREEN_SIZE: {
      return {
        ...state,
        screenSize: action.size,
      };
    }

    case SET_DEVICE_INFO: {
      const { deviceBrand, deviceModel, deviceVersion } = action;

      return {
        ...state,
        deviceBrand: deviceBrand || '',
        deviceModel: deviceModel || '',
        deviceVersion: deviceVersion || '',
      };
    }

    default:
      return state;
  }
};
